import React from 'react';
import clsx from 'clsx';

import styles from './Icon.module.scss';

export type IconName =
  | 'success'
  | 'error'
  | 'close'
  | 'search'
  | 'datepicker'
  | 'arrow-down'
  | 'arrow-right'
  | 'arrow-left'
  | 'chat'
  | 'contact-phone'
  | 'dashboard'
  | 'dependents'
  | 'edit'
  | 'email'
  | 'list'
  | 'phone'
  | 'record'
  | 'star'
  | 'star-empty'
  | 'support'
  | 'delete'
  | 'eye'
  | 'upload';

type IconProps = {
  name: IconName;
  className?: string;
  onClick?: () => void;
  id?: string;
};

export const Icon: React.FC<IconProps> = ({ name, className, onClick, ...args }) => (
  <i {...args} onClick={onClick} className={clsx(styles.icon, styles[`icon-${name}`], className)} />
);
